import { GraphQLNonNull, GraphQLInt, GraphQLID } from 'graphql'
import { AttackEventOrder, attackEventOrderType } from './attack-event-order'
import {
  attackEventFilterArgType,
  AttackEventFilterArg
} from './attack-event-filter-arg'

export interface AttackEventPagingArgs {
  readonly offset: number
  readonly limit: number
  readonly organizationID: string
  readonly orderBy?: AttackEventOrder
  readonly filters?: AttackEventFilterArg
}

export const attackEventPagingArgs = {
  offset: {
    description: 'The index in the collection to start at',
    type: new GraphQLNonNull(GraphQLInt)
  },
  limit: {
    description: 'The number of items to fetch',
    type: new GraphQLNonNull(GraphQLInt)
  },
  organizationID: {
    description: 'The unique ID for the organization being queried',
    type: new GraphQLNonNull(GraphQLID)
  },
  orderBy: {
    description: 'Options for ordering attack events',
    type: attackEventOrderType
  },
  filters: {
    description: 'Options for filtering attack events',
    type: attackEventFilterArgType
  }
}
